module.exports = __webpack_public_path__ + "static/fonts/Roboto-Bold.01e89ea.ttf";